/**
 * 项目详细信息实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Select,
    InputNumber,
    DatePicker,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';


/** 
* 日期样式
*/
import dayjs from 'dayjs';

const MODULENAME_URL = CNF.navItems[0].submenu[1].url;

const { TextArea } = Input;
const { Text } = Typography;


const Entity = (props) => {
    const { open, setOpen, record, refresh } = props;
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [rank, setRank] = useState(1);
    const [contractDate, setContractDate] = useState(currentDate);
    const [contractNumber, setContractNumber] = useState('');
    const [contractAmount, setContractAmount] = useState(0);
    const [projectLists, setProjectLists] = useState('');
    const [projectUlid, setProjectUlid] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setRank(1);
        setContractDate(currentDate);
        setContractNumber('');
        setContractAmount(0);
        setProjectUlid('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (open && record) {
            setRank(record.rank);
            setContractDate(record.contract_date ? record.contract_date : currentDate);
            setContractNumber(record.contract_number);
            setContractAmount(record.contract_amount);
            setProjectUlid(record.project_ulid);
        }
    }, [open, record]);

    useEffect(() => {
        const params = {
            rss: 'list',
            rank: 1,
            page_size: CNF.maxPageSize,
            current_index: 1
        };
        $.ajax({
            url: `${CNF.api}projects/bases${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    setProjectLists(data.dat);
                }
            }
        })
    }, []);


    const ok = () => {
        // 参数校验

        setLoading(true);

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                rank: rank,
                contract_date: contractDate,
                contract_number: contractNumber,
                contract_amount: contractAmount,
                project_ulid: projectUlid,
                description: description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={record ? record.name : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={12}><Text>项目层级</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={1}><Text>签订日期</Text><Text type='danger'>*</Text></Col>
                        <Col span={12}>
                            <Select
                                style={{ width: '100%' }}
                                value={rank}
                                onChange={(value) => setRank(value)}
                                disabled={loading}
                                options={[
                                    { value: 1, label: '主项目' },
                                    { value: 2, label: '子项目' }
                                ]}
                            />
                        </Col>
                        <Col span={11} offset={1}>
                            <DatePicker
                                placeholder='请选择日期'
                                style={{ width: '100%' }}
                                value={dayjs(contractDate, 'YYYY-MM-DD')}
                                onChange={(_, dateString) => setContractDate(dateString)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    {
                        rank > 1 ? <Row>
                            <Col span={24}><Text>父级项目</Text></Col>
                            <Col span={24}>
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder='请选择项目'
                                    style={{ width: '100%' }}
                                    value={projectUlid || undefined}
                                    onChange={(value) => setProjectUlid(value)}
                                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                                    options={projectLists && projectLists.map((item, index) => ({
                                        key: index,
                                        value: item.key,
                                        label: item.name,
                                    }))}
                                />
                            </Col>
                        </Row> : ''
                    }
                    <Row>
                        <Col span={12}><Text>合同编号</Text></Col>
                        <Col span={11} offset={1}><Text>合同金额</Text></Col>
                        <Col span={12}>
                            <Input
                                placeholder='请输入'
                                style={{ width: '100%' }}
                                value={contractNumber}
                                onChange={(e) => setContractNumber(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={11} offset={1}>
                            <InputNumber
                                style={{ width: '100%' }}
                                formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                min={0}
                                step='0.01'
                                value={contractAmount}
                                onChange={(value) => setContractAmount(value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>备注</Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='备注可写在这里...'
                                rows={2}
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity